import gql from 'graphql-tag';

/**
 * Select/picker dei DataViz.
 *
 * NB - la query lista dei DataViz si chiama "DataViz" (maiuscola, singolare): la
 * `generatePaginatedSelectQuery` generica produrrebbe "dataVizs", che non esiste nello
 * schema. DataVizFilterInput non supporta la ricerca testuale: si elencano tutti.
 */
export const DataVizSelectQuery = gql`
	query DataVizSelectQuery($filter: DataVizFilterInput) {
		choices: DataViz(filter: $filter) {
			edges {
				node {
					id
					localId
					name
				}
			}
			total
		}
	}
`;
